import React = require('react')
import i18next, { t } from 'i18next'
import { List } from 'immutable'
import { InView } from 'react-intersection-observer'
import { Link, navigate } from 'widgets-for-react'
import { MainLayout } from '../../../../../../main/main.layout'
import { blockInviewHandler } from '../../../drupal/rendering/inview_utils.mod'
import { PaginatedItem, SearchResultItem } from '../../../drupal/types_and_parser/extra_types.mod'
import { ParsedNodeUpdate } from '../../../drupal/types_and_parser/types.ext.gen'
import { loader } from '../../templates/loader.mod'
import { Pagination } from '../../templates/pagination.mod'
import { SearchSelectState } from './search_overview.state'

export const SearchOverview = (props: {
  status: 'loading' | 'loaded'
  page: PaginatedItem<SearchResultItem>
  contentTypeSelection: SearchSelectState
  updates: PaginatedItem<ParsedNodeUpdate>
  setPage: (page: number) => void
  setQuery: (query: string) => void
  runQuery: () => void
  setContentTypeFilter: (selection: string) => void
  current_page: number
  current_query: string
  suggestions: List<string>
  lang: string
  inert: boolean
  categoryCounts: { [key: string]: number }
  sortBy: string
  setSortBy: (sort: string) => void
}) => (
  <MainLayout className="main main--search-results" inert={props.inert}>
    <InView
      as="header"
      onChange={(inView) => blockInviewHandler('pageHeader', inView, 'io-page-header', 'inview')}
      triggerOnce={true}
      threshold={0}
      id="io-page-header"
      className="hero hero--results"
    >
      <div className="hero__inner ls-container ls-gutter">
        <div className="hero__content">
          <div className="hero__header">
            <h1 className="hero__label">{t('Header:Search')}</h1>
            <h1 className="hero__title title--m">{t('Common:Search.Title')}</h1>
          </div>
        </div>
        <div className="pageheader__visual fit-object">
          <img
            loading="eager"
            fetchpriority="high"
            className="pageheader__image"
            alt="Search overview banner"
            width="640"
            height="360"
            src="/frontend/images/search-results-header.jpg"
          />
        </div>
      </div>
    </InView>
    <div className="search-results">
          <section className="block block--search block--searchheader ls-block-spacing" key={'search-overview'}>
            <div className="block__inner ls-container">
              <div className="block__content">
                <div className="block__form">
                  <div className="block__grid">
                    <div className="block__column">
                      <label className="block__label text--s">
                        {t('Common:Search:term')}
                        <span className="sr-text">search</span>
                      </label>
                      <input
                        className="block__input"
                        autoFocus
                        type="search"
                        list="suggestions"
                        value={props.current_query}
                        onChange={(e) => props.setQuery(e.currentTarget.value)}
                        onKeyDown={(e) => {
                          if (e.keyCode == 13 && props.current_query != '' && props.current_query != undefined) {
                            // press enter
                            navigate(
                              `/${props.lang}/search/${encodeURIComponent(props.current_query)}/0${
                                props.contentTypeSelection.selection
                                  ? `?type=${props.contentTypeSelection.selection}`
                                  : ''
                              }`
                            )
                          }
                        }}
                      />
                      <datalist id="suggestions">
                        {props.suggestions.count() > 0 &&
                          props.suggestions
                            .map((s) => {
                              let clean = s.replace('\n', ' ')
                              return <option value={clean} key={clean} />
                            })
                            .toArray()}
                      </datalist>
                    </div>

                    <div className="block__column">
                      <label className="block__label tag--m" htmlFor="category">
                        {t('Common:Search:type')}
                        <span className="sr-text">type</span>
                      </label>
                      <select
                        className="block__dropdown"
                        name="category"
                        id="category"
                        defaultValue={props.contentTypeSelection.selection}
                        onChange={(e) => props.setContentTypeFilter(e.currentTarget.value)}
                      >
                        <option value="">{t('Common:Search:Select')}</option>
                        {props.contentTypeSelection.options?.map((v, k) => (
                          <option key={`${k}`} value={v.value}>{v.label} ({props.categoryCounts[v.value] || 0})</option>
                        ))}
                      </select>
                    </div>

                    <div className="block__column">
                      <label className="block__label tag--m" htmlFor="sort">
                        {t('Common:Search:sort')}
                        <span className="sr-text">sort</span>
                      </label>
                      <select
                        className="block__dropdown"
                        name="sort"
                        id="sort"
                        value={props.sortBy || 'relevance'}
                        onChange={(e) => props.setSortBy(e.currentTarget.value)}
                      >
                        <option value="relevance">{t('Common:Search:relevance')}</option>
                        <option value="date">{t('Common:Search:date')}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

        {props.status != 'loading' ? (
        <>
          {(!props.page || !props.page.items || !props.page.items[0]) &&
          (!props.updates || !props.updates.items || !props.updates.items[0]) &&
          props.page && props.page.pager ? (
            <section className="block block--results ls-block-spacing">
              <div className="block__inner ls-container">
                <div className="ls-columns">
                  <div className="ls-columns__main">
                    {props.current_query && props.page && props.page.items && props.page.items.length === 0 ? (
                      <p className="search-results__text text--styled text--spacing">
                        <p>{t('Common:Search:no_results')}</p>
                        <ul>
                          <li>{t('Common:Search:first_text')}</li>
                          <li
                            lang={i18next.language == 'en' ? 'nl' : 'en'}
                            dangerouslySetInnerHTML={{ __html: t('Common:Search:second_text') }}
                          ></li>
                        </ul>
                      </p>
                    ) : (
                      <p className="search-results__text"></p>
                    )}
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <section className="block block--results ls-block-spacing">
              <div className="block__inner ls-container">
                <div className="ls-columns">
                  {((props.page && props.page.items && props.page.items.length > 0) || (props.updates && props.updates.items && props.updates.items.length > 0)) && (
                    <header className="block__header ls-columns__header">
                      <h2 className="block__title title--l">Results</h2>
                    </header>
                  )}
                  <div className="block__content ls-columns__main">
                    <ul className="block__list blocklist">
                      {props.page && props.page.items && props.page.items.map((item) => <SearchItem {...item} />)}

                      {/* FIXME: Disabled as part of SVVO-271 */}
                      {/* {props.updates && props.updates.items && props.updates.items.filter(update => !(props.page && props.page.items ? props.page.items.map(x => x.id).toArray() : []).includes(update.id))
                      .map((update) => {
                        let search_item: SearchResultItem = {
                          bundle: update.bundle,
                          url: update.language_links.get(update.language),
                          title: update.field_introduction,
                          introduction: update.created.format('D MMMM YYYY'),
                          content: { content: update.field_category.map(x => x.description).toArray() },
                          id: update.id,
                          categories: update.field_category.reduce((xs, x, i) => xs + x.label + (update.field_category.count() - 1 == i ? "" : ", "), "")
                        }
                        return (
                          <SearchItem {...search_item} />
                        )
                      })} */}
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          )}

          {props.page && props.page.pager && props.updates && props.updates.pager ? (
            <Pagination
              pager={
                props.page.pager.total_pages > props.updates.pager.total_pages ? props.page.pager : props.updates.pager
              }
              setPage={props.setPage}
            />
          ) : props.page && props.page.pager ? (
            <Pagination pager={props.page.pager} setPage={props.setPage} />
          ) : (
            props.updates && props.updates.pager && <Pagination pager={props.updates.pager} setPage={props.setPage} />
          )}
        </>
      ) : (
        <section className="search-results__section ls-block-spacing">{loader.run((_) => {})}</section>
      )}
    </div>
  </MainLayout>
)

export const SearchItem = (search_item: SearchResultItem) => {
  return (
    <li className=" blocklist__item">
      <Link className="blocklist__link" to={search_item.url}>
        <h3 className="blocklist__title title--s">{search_item.title}</h3>
        <p className="blocklist__subtitle">{search_item.content}</p>
        {search_item.categories && <p className="blocklist__label tag--m">{search_item.categories}</p>}
      </Link>
    </li>
  )
}
